import config from 'config';

export const prefixAccount = () => {
  return config.usernamePrefix.ignoreChar;
};



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer/utils.ts